// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/hash.js';

import { paths } from '../generated/hash';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('hash', Original, paths);
